const sessionStorageKey = (key: string, id: string) =>
  `_scored_data_${key}_${id}`;

export const getLocalItem =
  <T>(key: string, defaultValue: T) =>
  (id: string): T => {
    try {
      const data = globalThis.sessionStorage.getItem(
        sessionStorageKey(key, id),
      );
      return data ? JSON.parse(data) : defaultValue;
    } catch {
      return defaultValue;
    }
  };

export const setLocalItem =
  <T>(key: string) =>
  (id: string, data?: T) => {
    const storageKey = sessionStorageKey(key, id);

    if (!data) {
      globalThis.sessionStorage.removeItem(storageKey);
    } else {
      globalThis.sessionStorage.setItem(storageKey, JSON.stringify(data));
    }
  };

export const localStorage = <T>(key: string, defaultValue: T) => {
  return {
    get: getLocalItem<T>(key, defaultValue),
    set: setLocalItem<T>(key),
  };
};
